<template>
    <div style="height: 100%">
        <webix-scheduler :conf="{id: 2}"/>
    </div>
</template>

<script>
    import WebixScheduler from "../components/webix/WebixScheduler";
    export default {
        components: {WebixScheduler}
    };
</script>

<style scoped>

</style>
